import React from 'react'
import AllStars from './Star'

const Review = ({ obj }) => {
    const colors = [
        "#3f51b5", // indigo
        "#4caf50", // green
        "#9c27b0", // purple
        "#2196f3", // blue
        "#ff9800", // orange
        "#e91e63", // pink
        "#673ab7", // deep purple
        "#00bcd4", // cyan
        "#8bc34a", // light green
    ];
    const handleColor = () => {
        const newColor = colors[Math.floor(Math.random() * colors.length)];
        return newColor
    };
    return (
        <div style={{ marginBottom: 30 }}>
            <div style={{ display: 'flex', marginBottom: 8, alignItems: 'center' }}>
                <div>
                    {obj.img && <img style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: '50%' }} src={obj.img} />}
                    {!obj.img && <div style={{ width: 42, height: 42, objectFit: 'cover', borderRadius: '50%', backgroundColor: handleColor() }}>
                        <p style={{ color: 'white', width: '100%', height: '100%', fontSize: 18, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {obj.name[0]}
                        </p></div>}
                </div>
                <p style={{ fontWeight: 'bold', fontSize: 15, marginLeft: 12 }}>{obj.name}</p>
            </div>
            <div style={{ display: 'flex', height: 30, gap: 10 }}>
                <p><AllStars rating={obj.rating} /> </p>
                <p style={{ display: 'flex', alignItems: 'center', height: 30, paddingTop: 4, color: '#333333', fontSize: 15, marginTop: 0 }}>{obj.date}</p>
            </div>
            <p style={{ margin: 0, color: '#333333', fontSize: 14 }}>
                {obj.reviewData}
            </p>
        </div>
    )
}

export default Review